import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";

import {ImDataImportComponent} from "../component/protected-components/im-data-import/im-data-import.component";
import {
    ImSchemaFullComponent
} from "../component/protected-components/im-schema-object-component/view/full/im-schema-full.component";
import {
    ImTestComponent
} from "../component/protected-components/im-schema-object-component/view/shared/im-test-component/im-test.component";
import {
    ImSchemaSideComponent
} from "../component/protected-components/im-schema-object-component/view/side/im-schema-side.component";
import {
    ImSchemaObjectComponent
} from "../component/protected-components/im-schema-object-component/im-schema-object.component";
import {ImViewImportComponent} from "../component/protected-components/im-view-import/im-view-import.component";
import {
    ImImportDataComponent
} from "../component/object-components/object-component/shared/im-import-data/im-import-data.component";
import {
    ImImportRecordComponent
} from "../component/object-components/object-component/shared/im-import-record/im-import-record.component";
import {
    ImImportObjectFullComponent
} from "../component/object-components/object-component/view/im-import-object-full-component/im-import-object-full.component";
import {
    ImImportObjectSideComponent
} from "../component/object-components/object-component/view/im-import-object-side-component/im-import-object-side.component";
import {ImImportObjectComponent} from "../component/object-components/object-component/im-import-object.component";
import {ImKpiComponent} from "../page/im-overview-page/components/kpiComponent/im-kpi.component";
import {ImStatisticsComponent} from "../page/im-overview-page/components/statisticsComponent/im-statistics.component";
import {ImConfigPage} from "../page/overview/im-config/im-config.page";
import {ImDashboardPage} from "../page/overview/im-dashboard/im-dashboard.page";

const imModuleEntry: TestModuleDefinition = {
  key: 'im',
  label: 'Import Management (im)',
  components: [
    {
      key: 'imDataImportComponent',
      component: ImDataImportComponent,
      selector: 'mvs-im-data-import',
      type: 'component',
      label: 'Data Import'
    },
    {
      key: 'imSchemaObjectComponent',
      component: ImSchemaObjectComponent,
      selector: 'im-schema-object-base-component',
      type: 'ObjectBaseComponent',
      label: 'Schema Object'
    },
    {
      key: 'imSchemaFullComponent',
      component: ImSchemaFullComponent,
      selector: 'im-schema-full',
      type: 'ImSchemaBaseComponent',
      label: 'Schema Full'
    },
    {
      key: 'imSchemaSideComponent',
      component: ImSchemaSideComponent,
      selector: 'im-schema-side',
      type: 'ImSchemaBaseComponent',
      label: 'Schema Side'
    },
    {
      key: 'imTestComponent',
      component: ImTestComponent,
      selector:'im-test-component',
      type: 'component',
      label: 'Test Component'
    },
    {
      key: 'imViewImportComponent',
      component: ImViewImportComponent,
      selector: 'mvs-im-view-import',
      type: 'component',
      label: 'View Import'
    },
    {
      key: 'imImportObjectComponent',
      component: ImImportObjectComponent,
      selector: 'im-import-object-component',
      type: 'ObjectBaseComponent',
      label: 'Import Object'
    },
    {
      key: 'imImportObjectFullComponent',
      component: ImImportObjectFullComponent,
      selector: 'im-import-object-full',
      type: 'ImImportObjectBaseComponent',
      label: 'Import Object Full'
    },
    {
      key: 'imImportObjectSideComponent',
      component: ImImportObjectSideComponent,
      selector: 'im-import-object-side',
      type: 'ImImportObjectBaseComponent',
      label: 'Import Object Side'
    },
    {
      key: 'imImportDataComponent',
      component: ImImportDataComponent,
      selector: 'im-import-data',
      type: 'component',
      label: 'Import Data'
    },
    {
      key: 'imImportRecordComponent',
      component: ImImportRecordComponent,
      selector: 'im-import-record',
      type: 'component',
      label: 'Import Record'
    },
    {
      key: 'ImKpiComponent',
      component: ImKpiComponent,
      selector: 'im-kpi-component',
      type: 'OverviewKpiBaseComponent',
      label: 'im kpi component'
    },
    {
      key: 'ImStatisticsComponent',
      component: ImStatisticsComponent,
      selector: 'im-statistics',
      type: 'OverviewStatisticsBaseComponent',
      label: 'im statistics'
    },
    {
      key: 'ImConfigPage',
      component: ImConfigPage,
      selector: 'mvs-im-config-page',
      type: 'PageComponent',
      label: 'mvs im config page'
    },
    {
      key: 'ImDashboardPage',
      component: ImDashboardPage,
      selector: 'mvs-im-dashboard-page',
      type: 'PageComponent',
      label: 'mvs im dashboard page'
    }
  ]
};

export const IM_TEST_PROVIDERS: Provider[] = [
  { provide: TEST_MODULE_REGISTRY, useValue: imModuleEntry, multi: true }
];


